// @ts-check

/**
 * Detects whether the device supports touch input at all — as a primary
 * OR secondary input mechanism (e.g. a touchscreen laptop with a mouse/
 * trackpad as its primary pointer still reports true here). This answers
 * "can the user interact via touch"; it does NOT imply a mobile device,
 * or even a tablet — see `isMobile` for device identity.
 * Prefers an any-pointer capability query (works across browsers,
 * unaffected by user-agent spoofing), OR'd with touch point support.
 * @returns {boolean}
 */
const isTouch = () => {
  if (window.matchMedia && window.matchMedia("(any-pointer: coarse)").matches) {
    return true;
  }

  return navigator.maxTouchPoints > 0;
};

export default isTouch;
